import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Reviews from './pages/Reviews';
import ReviewAnalytics from './pages/ReviewAnalytics';
import CategoryInsights from './pages/CategoryInsights';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/auth/PrivateRoute';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route for login */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Private routes that require authentication */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/analytics" element={<ReviewAnalytics />} />
            <Route path="/insights" element={<CategoryInsights />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Route>
        
        {/* Catch all route - redirect to login or dashboard based on auth status */}
        <Route 
          path="*" 
          element={
            localStorage.getItem('isAuthenticated') === 'true' 
              ? <Navigate to="/" replace /> 
              : <Navigate to="/login" replace />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;